import * as ActionTypes from 'constants';

export const fetchRecentImpacts = clientId => ({
  type : ActionTypes.FETCH_CLIENT_RECENT_IMPACTS,
  payload : { id: clientId }
});

export const receiveRecentImpacts = impacts => ({
  type: ActionTypes.RECEIVE_CLIENT_RECENT_IMPACTS,
  payload: { impacts }
});

export const addIncident = incident => ({
  type: ActionTypes.ADD_CLIENT_INCIDENT,
  payload: { incident }
});

export const fetchIncident = id => ({
  type: ActionTypes.FETCH_CLIENT_INCIDENT,
  payload: { id }
});

export const fetchIncidents = client => ({
  type: ActionTypes.FETCH_CLIENT_INCIDENTS,
  payload: { client }
});

export const updateIncident = incident => ({
  type: ActionTypes.UPDATE_INCIDENT,
  payload: { incident }
});

export const fetchNextIncidents = client => ({
  type: ActionTypes.FETCH_CLIENT_NEXT_INCIDENTS,
  payload: { client }
});

export const receiveIncidents = incidents => ({
  type: ActionTypes.RECEIVE_CLIENT_INCIDENTS,
  payload: { incidents }
});

export const previewIncident = incident => ({
  type: ActionTypes.PREVIEW_INCIDENT,
  payload: { incident }
});

export const startCreateIncident = () => ({
  type: ActionTypes.START_CREATE_INCIDENT
});

export const hideCreateIncident = () => ({
  type: ActionTypes.HIDE_CREATE_INCIDENT
});

export const addIncidentReportPDF = (file) => ({
  type : ActionTypes.ADD_INCIDENT_REPORT_PDF,
  payload : file
})

export const createIncidentReport = () => ({
  type : ActionTypes.GENERATE_INCIDENT_REPORT
})

export const toggleIncidentReportSelected = (val, id) => ({
  type : ActionTypes.TOGGLE_INCIDENT_REPORT_SELECTED,
  payload : {val, id}
})

export const toggleGeneratingReport = (val) => ({
  type : ActionTypes.TOGGLE_GENERATING_REPORT,
  payload : val
})

export const promptNewReportDownload = (report_link) => ({
  type : ActionTypes.PROMPT_NEW_REPORT_DOWNLOAD,
  payload : report_link
})

export const hideNewReportPrompt = () => ({
  type : ActionTypes.HIDE_NEW_REPORT_PROMPT
})

export const beginDeleteReportPDFS = () => ({
  type : ActionTypes.BEGIN_DELETE_REPORT_PDFS
})

export const deleteReportPDFS = () => ({
  type : ActionTypes.DELETE_REPORT_PDFS
})

export const toggleDeletingReportPDFS = (val) => ({
  type : ActionTypes.TOGGLE_DELETING_REPORT_PDFS,
  paylad : val
})



// WEBPACK FOOTER //
// ./src/common/actions/client_incidents.js